import {FormatPrice} from '@/utils/general-data';

export const ProcessInputValue = (event, type) => {
  let value = event.srcElement.value;
  let result;
  
  switch(type) {
    case 'price':
      value = value.replace(/,/g, '.').replace(/[^0-9.]+/g, '');
      result = value ? Math.round(parseFloat(value).toFixed(2) * 100) : 0;
      event.srcElement.value = FormatPrice(result);
      break;
    case 'percent':
      value = value.replace('%', '').replace(/[^0-9]+/g, '');
      result = value ? parseInt(value) : 0;

      if (result > 100)
        result = 100;

      event.srcElement.value = `${result}%`;
      break;
    case 'number':
      value = parseInt(value.replace(/[^0-9]+/g, '')) || 0;
      result = value;
      event.srcElement.value = result;
      break;
    default:
      break;
  }
  
  return result;
}